module.exports = __webpack_public_path__ + "static/ehlvr_1-564c3ac7868f2841c1ed1d7256451007.png";